module.exports = __webpack_public_path__ + "static/media/Hardware_Track_Icon.f7b49bd3.svg";